import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
import { SERVICE_AREAS } from '../data/serviceAreas';
const LINKS = [{
  label: 'Clientes',
  to: '/#clientes'
}, {
  label: 'Contacto',
  to: '/#contacto'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const servicesRef = useRef<HTMLLIElement>(null);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
    setServicesOpen(false);
    setMobileServicesOpen(false);
  }, [location.pathname, location.hash]);
  useEffect(() => {
    const onClickOutside = (event: MouseEvent) => {
      if (servicesRef.current && !servicesRef.current.contains(event.target as Node)) {
        setServicesOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-all duration-300 ${scrolled ? 'border-white/15 bg-vm-bg/95 backdrop-blur-md' : 'border-transparent bg-transparent'}`} data-id="element-142" data-mp="ojnp45jn1cj9">
      <nav className="mx-auto flex h-24 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-143" data-mp="w5wy8wgocfr">
        <Link to="/" aria-label="Vivo Media — Inicio" className="flex h-20 w-[260px] shrink-0 items-center overflow-hidden sm:h-24 sm:w-[340px]" data-id="element-144" data-mp="5mw1xl0z6d9x">
          <img src="https://cdn.magicpatterns.com/uploads/mzH2PN3mqF9aVPxsFuUwSS/logo_png_blanco.png" alt="Vivo Media — Tecnología visual en movimiento" className="h-full w-full origin-left scale-[2] object-contain object-left" data-id="element-145" data-mp="34b1voc9p2vvu" />
        </Link>

        <ul className="hidden items-center gap-8 md:flex" data-id="element-146" data-mp="2wa40yhgq7arx">
          <li data-id="element-147" data-mp="3b01iiek5h285">
            <Link to="/#quienes-somos" className="text-sm font-medium uppercase tracking-[0.08em] text-white transition-colors hover:text-vm-muted" data-id="element-148" data-mp="3b0jlrv58cgpk">
              Nosotros
            </Link>
          </li>

          <li ref={servicesRef} className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-149" data-mp="2ddcbfqalbzff">
            <button type="button" onClick={() => setServicesOpen(v => !v)} aria-expanded={servicesOpen} aria-haspopup="true" className="flex items-center gap-1.5 text-sm font-medium uppercase tracking-[0.08em] text-white transition-colors hover:text-vm-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-sky" data-id="element-150" data-mp="2nbrztli8gul8">
              Servicios
              <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${servicesOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-151" data-mp="f4wydqk2c616" />
            </button>

            {servicesOpen && <div className="absolute left-1/2 top-full w-72 -translate-x-1/2 pt-4" data-id="element-152" data-mp="57iq4e8amnjy">
                <ul className="overflow-hidden rounded-2xl border border-white/15 bg-vm-bg shadow-xl shadow-black/30" data-id="element-153" data-mp="sxd2kuopaa3o">
                  {SERVICE_AREAS.map(area => {
                const Icon = area.icon;
                return <li key={area.slug} data-id="element-154" data-mp="o41wivrppxct">
                        <Link to={`/servicios/${area.slug}`} className="flex items-center gap-3 border-b border-white/10 px-5 py-4 text-sm font-medium text-white transition-colors last:border-b-0 hover:bg-white/10" data-id="element-155" data-mp="o2qr6rimchjl">
                          <Icon className="h-5 w-5 shrink-0 text-vm-sky" strokeWidth={1.5} aria-hidden="true" data-id="element-156" data-mp="3p3i5eop7zz4v" />
                          {area.name}
                        </Link>
                      </li>;
              })}
                </ul>
              </div>}
          </li>

          {LINKS.map(link => <li key={link.to} data-id="element-157" data-mp="bmram8d02drl">
              <Link to={link.to} className="text-sm font-medium uppercase tracking-[0.08em] text-white transition-colors hover:text-vm-muted" data-id="element-158" data-mp="blpmp3avxwsg">
                {link.label}
              </Link>
            </li>)}
        </ul>

        <Link to="/#contacto" className="hidden items-center rounded-2xl bg-vm-sky px-5 py-2 text-sm font-semibold uppercase tracking-[0.1em] text-vm-bg transition-colors hover:bg-vm-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-sky focus-visible:ring-offset-4 focus-visible:ring-offset-vm-bg md:inline-flex" data-id="element-159" data-mp="3u1tj5aimytsd">
          Contactar
        </Link>

        <button type="button" onClick={() => setOpen(v => !v)} className="p-2 text-white md:hidden" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} data-id="element-160" data-mp="2d7v1tgr4bi1s">
          {open ? <XIcon className="h-6 w-6" data-id="element-161" data-mp="2mamfzobdorx4" /> : <MenuIcon className="h-6 w-6" data-id="element-162" data-mp="2r8fjuap7l9u8" />}
        </button>
      </nav>

      {open && <div className="border-t border-white/15 bg-vm-bg md:hidden" data-id="element-163" data-mp="2r6l9fqbkd04e">
          <ul className="space-y-4 px-6 py-6" data-id="element-164" data-mp="2w5xxgee68d8k">
            <li data-id="element-165" data-mp="30yhclfsibgfh">
              <Link to="/#quienes-somos" className="block text-sm font-medium uppercase tracking-[0.1em] text-white transition-colors hover:text-vm-muted" data-id="element-166" data-mp="30xz67qc4rltu">
                Nosotros
              </Link>
            </li>

            <li data-id="element-167" data-mp="3ey06b3kkmp89">
              <button type="button" onClick={() => setMobileServicesOpen(v => !v)} aria-expanded={mobileServicesOpen} className="flex w-full items-center justify-between text-sm font-medium uppercase tracking-[0.1em] text-white transition-colors hover:text-vm-muted" data-id="element-168" data-mp="3exgyifomxh7y">
                Servicios
                <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${mobileServicesOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-169" data-mp="1ondbfnd3h5xc" />
              </button>

              {mobileServicesOpen && <ul className="mt-4 space-y-3 border-l border-white/15 pl-4" data-id="element-170" data-mp="1tk3riaowg1ir">
                  {SERVICE_AREAS.map(area => <li key={area.slug} data-id="element-171" data-mp="27i2358bu5juk">
                      <Link to={`/servicios/${area.slug}`} className="block text-sm font-light text-vm-muted transition-colors hover:text-white" data-id="element-172" data-mp="22md3l4ztg2y9">
                        {area.name}
                      </Link>
                    </li>)}
                </ul>}
            </li>

            {LINKS.map(link => <li key={link.to} data-id="element-173" data-mp="2osfkvifii55h">
                <Link to={link.to} className="block text-sm font-medium uppercase tracking-[0.1em] text-white transition-colors hover:text-vm-muted" data-id="element-174" data-mp="2ovl8sucen0zm">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>}
    </header>;
}